import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { CATEGORIES } from "../../lib/api";

export default function CategoryGrid() {
  const nav = useNavigate();
  return (
    <section className="px-4 sm:px-6 max-w-7xl mx-auto" data-testid="category-grid">
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="uppercase-label text-[#FF6B35]">Explorer par catégorie</div>
          <h2 className="font-display font-black text-2xl sm:text-3xl tracking-tighter text-[#1A1A1A] mt-1">
            Que cherches-tu aujourd'hui ?
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
        {CATEGORIES.map((cat, i) => {
          const Icon = Icons[cat.icon] || Icons.Sparkles;
          return (
            <motion.button
              key={cat.id}
              data-testid={`cat-${cat.id}`}
              onClick={() => nav(`/explore?category=${cat.id}`)}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group relative aspect-[4/5] sm:aspect-square rounded-3xl overflow-hidden text-left shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <img src={cat.image} alt={cat.label} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, ${cat.color}33 0%, ${cat.color}DD 100%)` }} />
              <div className="absolute inset-0 p-4 flex flex-col justify-between text-white">
                <div className="w-9 h-9 rounded-xl bg-white/25 backdrop-blur-md flex items-center justify-center border border-white/30">
                  <Icon size={18} strokeWidth={2.5} />
                </div>
                <div>
                  <div className="font-display font-black text-lg sm:text-xl leading-tight text-shadow-soft">{cat.label}</div>
                  <div className="text-[11px] font-medium opacity-90 mt-0.5">{cat.tagline}</div>
                </div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </section>
  );
}
